export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";